// eslint-disable-next-line no-unused-vars
/* global Uint8Array */
// TODO take these exceptions away once we have enough test coverage to catch regressions while fixing these linting errors
/* eslint complexity: "off" , max-depth: "off", max-statements: "off", max-len: "off" */
import $ from 'jquery';
import { defaults, template } from 'underscore';
import cfg from './environment';
import util from './custom-content-util';
import { getAppLink, getQueryVariable, parseSamlRequest } from './saml-redirect-util';

function init(window) {
  var env = cfg.getOktaEnvironment(window.location.host);

  window.addEventListener('message', receiveMessage.bind(null, env, window), false);

  $('body').append('<iframe id="account-chooser-iframe" src="/discovery/iframe.html" style="display:none;"></iframe>');

  $('#btn-account-sign-in').click(function (e) {
    e.preventDefault();
    var subdomain = $('#subdomain').val();
    if (subdomain) {
      var orgUrl = 'https://' + subdomain.trim() + '.' +
        $('#okta-options option:selected').text().trim();
      window.location.replace(getAppLink(window, orgUrl));
    } else {
      $('#subdomain').addClass('shake');
    }
  });

  // MyOkta sign-in link click event
  $('#myokta-sign-in-link').click(function (e) {
    e.preventDefault();
    window.location.href = `/signin/${window.location.search}`;
  });

  $('#subdomain').keydown(function (e) {
    if (e.keyCode == 13) {
      $('#btn-account-sign-in').click();
    } else {
      $('#subdomain').removeClass('shake');
    }
  });

  $('#link-add-account').click(function (e) {
    e.preventDefault();
    $('#add-account-form').show();
    $('.registration-container').show();
    $('.free-trial-container').show();
    $('#account-chooser-form').hide();
  });

  $('#okta-account-chooser div.accounts-content').on('click', 'div.account-remove', function (e) {
    e.preventDefault();
    sendMessage(env, 'remove_account', {
      accountId: $(this).parents('.account-container').data('id')
    });
  });

  var request = getQueryVariable(window.location.search, 'SAMLRequest');
  var issuer = parseSamlRequest(request);
  util.updatePortalContent(issuer);
  addAdditionalOktaOptions(env.trustedRootDomains);
}

function addAdditionalOktaOptions(trustedRootDomains) {
  let isTrexEnvAllowed = false;
  let isClouditudeEnvAllowed = false;
  // IE does not support Array.includes
  for (var i = 0; i < trustedRootDomains.length; i++) {
    isTrexEnvAllowed = trustedRootDomains[i] === 'trexcloud.com' ? true : false;
    isClouditudeEnvAllowed = trustedRootDomains[i] === 'clouditude.com' ? true : false;
  }
  if (isTrexEnvAllowed) {
    $('#okta-options').append('<option value="trexcloud.com">trexcloud.com</option>');
  }
  if (isClouditudeEnvAllowed) {
    $('#okta-options').prepend('<option value="clouditude.com">clouditude.com</option>');
    $('#okta-options')[0].selectedIndex = 0;
  }
}

function sendMessage(env, messageType, data) {
  data = data || {};
  var iframeWin = document.getElementById('account-chooser-iframe').contentWindow;
  iframeWin.postMessage(
    defaults(data, { messageType: messageType }),
    env.iframeOrigin);
}

function renderAccounts(window, accounts) {
  var accountTmpl = template(
    '<div class="account-container" data-id="<%- id %>">\
        <div class="account-content">\
          <table>\
            <tr>\
              <td>\
                <div class="account-remove">\
                </div>\
              </td>\
              <td>\
                <a href="<%- acsUrl %>">\
                  <div class="account-logo">\
                    <img src="<%- orgUrl %>/.well-known/logo" />\
                  </div>\
                </a>\
              </td>\
              <td>\
                <a href="<%- acsUrl %>">\
                  <div class="account-info">\
                    <p class="name" title="<%- displayName %>"><%- displayName %></p>\
                    <p class="email" title="<%- login %>"><%- login %></p>\
                    <p class="orgUrl" title="<%- orgUrlNoProtocol %>"><%- orgUrlNoProtocol %></p>\
                  </div>\
                </a>\
              </td>\
              <td>\
                <a href="<%- acsUrl %>">\
                  <div class="account-arrow"></div>\
                </a>\
              </td>\
            </tr>\
          </table>\
        </div>\
    </div>'
  );

  var el = $('#accounts-content');
  el.html('');
  accounts.forEach(function (account) {
    var orgUrl = account.origin;
    var orgUrlNoProtocol = account.origin.replace(/^https?:\/\//i, '');
    el.append(accountTmpl({
      id: account.id,
      orgUrl: orgUrl,
      orgUrlNoProtocol: orgUrlNoProtocol,
      acsUrl: getAppLink(window, orgUrl),
      login: account.login,
      displayName: account.displayName
    }));
  });
}

function displayChooser(accounts) {
  if (accounts && accounts.length) {
    $('.free-trial-container').hide();
    $('#account-chooser-form').show();
    $('.registration-container').hide();
    $('#add-account-form').hide();
  } else {
    $('.free-trial-container').show();
    $('#account-chooser-form').hide();
    $('.registration-container').show();
    $('#add-account-form').show();
  }
  $('#okta-account-chooser').show();
}

function receiveMessage(env, currentWindow, event) {
  var accounts, el;
  if (validateEvent(env, event)) {
    switch (event.data.messageType) {
    case 'iframe_loaded':
      sendMessage(env, 'get_accounts');
      break;
    case 'processed_get_accounts':
      if (event.data.accounts && event.data.accounts.length) {
        accounts = event.data.accounts;
        renderAccounts(currentWindow, accounts);
      }
      displayChooser(accounts);
      break;
    case 'processed_remove_account':
      if (event.data.accountId) {
        el = $('#okta-account-chooser [data-id="' + event.data.accountId + '"]');
        if (el) {
          if ($('#okta-account-chooser div.account-container').length === 1) {
            displayChooser();
          } else {
            el.remove();
          }
        }
      }
      break;
    case 'get_accounts_json':
      // An incoming postMessage from an approved domain will return a JSON
      // representation of the stored accounts.
      accounts = getAccounts(currentWindow);
      event.source.postMessage(accounts, event.origin);
      break;
    }
  }
}

function validateEvent(env, event) {
  // Validates the incoming event by checking:
  //   - Does the iframeOrigin exactly match the event origin OR
  //   - Is the iframeOrigin included in the trustedOrigins
  //   - Event contains a postMessage data object
  var validOrigin = (event.origin === env.iframeOrigin || env.trustedOrigins.includes(event.origin));
  return (validOrigin && event.data && event.data.messageType);
}

function getAccounts(currentWindow) {
  try {
    var accounts = currentWindow.localStorage.getItem('okta_accounts');
    return accounts ? JSON.parse(accounts) : [];
  }
  catch (e) {
    return [];
  }
}

module.exports = {
  init,
  renderAccounts,
  receiveMessage,
  getAccounts,
  addAdditionalOktaOptions
};


// WEBPACK FOOTER //
// ./lib/my-okta-ui.js